
import { DxNumberBox } from "devextreme-vue/number-box";
import { defineComponent } from "vue";
import DxValidator, { DxRequiredRule } from "devextreme-vue/validator";

export default defineComponent({
  components: {
    DxNumberBox,
    DxValidator,
    DxRequiredRule,
  },
  emits: ["update:value", "changed"],
  props: {
    //показатель видимости контрола
    visible: { type: Boolean, required: false, default: true },
    //показатель валидации
    isValid: { type: Boolean, required: false, default: true },
    //минимальное значение
    min: { type: Number, required: false, default: undefined },
    //максимальное значение
    max: { type: Number, required: false, default: undefined },
    //placeholder
    placeholder: { type: String, required: false, default: "" },
    //показатель возможности изменения значения
    readOnly: { type: Boolean, required: false, default: false },
    //показатель возможности взаимодействия
    disabled: { type: Boolean, required: false, default: false },
    //отображать кнопку очистки значения
    hasEmptyValue: { type: Boolean, required: false, default: false },
    //подсказка при наведении на контрол
    hint: { type: String, required: false, default: undefined },
    //значение
    value: { type: Number, required: false },
    //группа валидации (см. dxValidator.validationGroup)
    validationGroup: { required: false, default: "baseValidationGroup" },

    stylingMode: {},

    contentReady: {
      type: Function,
      required: false,
      default: () => {
        return;
      },
    },
    enterKey: {
      type: Function,
      required: false,
      default: () => {
        return;
      },
    },
  },
  methods: {
    //события
    valueChanged(e: any) {
      this.$emit("update:value", e.value);
      this.$emit("changed", e);
    },
  },
  data() {
    return {
      modelValue: null,
      formatStr: "",
    };
  },
  created() {
    (this as any).modelValue = this.value;
  },
});
